<template>
    <div class="box">
        <el-form label-width="auto">

            <SectionTitle title="基础信息" />
            <el-form-item label="标题">
                <el-input v-model="myObj.bottom_list_theme_params.title" placeholder="请输入"></el-input>
            </el-form-item>

            <SectionTitle title="数据选择" />
            <el-form-item label="每页个数">
                <el-input-number v-model="myObj.source_list.params.per_page" :min="1"></el-input-number>
            </el-form-item>

            <SectionTitle title="样式设置" />
            <el-form-item label="展示类型">
                <el-select v-model="myObj.bottom_list_theme_params.show_type" placeholder="请选择">
                    <el-option v-for="item, index in showTypeOptions" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="左右间距">
                <el-input-number v-model="myObj.bottom_list_theme_params.margin" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素间距">
                <el-input-number v-model="myObj.bottom_list_theme_params.between_space" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素圆角">
                <el-input-number v-model="myObj.bottom_list_theme_params.corner_radius" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="高度比例" v-if="myObj.bottom_list_theme_params.show_type == 'photolist'">
                <el-input-number v-model="myObj.bottom_list_theme_params.item_height_ratio" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="每列个数">
                <el-radio-group v-model="myObj.bottom_list_theme_params.column">
                    <el-radio :label="2">2个</el-radio>
                    <el-radio :label="3">3个</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="显示点赞">
                <el-switch v-model="myObj.bottom_list_theme_params.show_like" :active-value="1"
                    :inactive-value="0"></el-switch>
            </el-form-item>

            <el-form-item label="显示作者">
                <el-switch v-model="myObj.bottom_list_theme_params.show_author" :active-value="1"
                    :inactive-value="0"></el-switch>
            </el-form-item>

            <el-form-item label="显示底栏">
                <el-switch v-model="myObj.bottom_list_theme_params.show_bottom_view" :active-value="1"
                    :inactive-value="0"></el-switch>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
import { GetAtlasCategoryList, GetAtlasTagList } from '@/request/api'

import SectionTitle from '@/components/SectionTitle.vue';
export default {
    name: "BottomListThemeProp",
    components: {
        SectionTitle
    },
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,
            showTypeOptions: [
                { name: '图片列表样式', value: 'photolist' },
                { name: '瀑布流样式', value: 'waterfall' }],
            queryCategory: '',
            queryTag: ''
        }
    },
    mounted() {
        this.queryCategory = this.myObj.source_list.ignore.category_name
        this.queryTag = this.myObj.source_list.ignore.tag_name
    },
    methods: {
    }
}
</script>

<style scoped lang="less">
.box {
    padding: 15px;
}
</style>